import React from "react";
import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps, Tooltip } from "@mui/material";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import { useTranslation } from "react-i18next";

const ToggleLayout: React.FC<ToggleButtonGroupProps> = (props) => {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup exclusive {...props} aria-label="Display mode">
      <Tooltip title={t("tooltip:title.viewThumbs")}>
        <ToggleButton value="grid" aria-label="Grid view" size="small" sx={{ width: 28, height: 28 }}>
          <GridViewOutlinedIcon />
        </ToggleButton>
      </Tooltip>
      <Tooltip title={t("tooltip:title.viewList")}>
        <ToggleButton value="list" aria-label="List view" size="small" sx={{ width: 28, height: 28 }}>
          <TableRowsOutlinedIcon />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default ToggleLayout;
